/**
 * Resolves the current branch id from localStorage for loyalty API params.
 *
 * The axios interceptor already sends a `branch-id` HEADER from this same
 * source (`src/lib/axios/index.ts`), but the loyalty backend reads `branchId`
 * as a query/body PARAM — so the loyalty service layer must pass it explicitly.
 * Guard mirrors the interceptor: rejects unset / 'undefined' / 'null' /
 * non-numeric values.
 *
 * @returns the numeric branch id, or null when no valid branch is selected.
 */
export const getCurrentBranchId = (): number | null => {
  const raw = localStorage.getItem('currentBranch')
  if (!raw || raw === 'undefined' || raw === 'null' || isNaN(Number(raw))) {
    return null
  }
  return Number(raw)
}
